import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Store } from '../rootReducer';
import { languageSelect } from '../Settings/SettingsActions';
import LanguageSelect, { DispatchFromProps } from './LanguageSelect';
import { LanguageCode } from '@pdcplan/shared/generated/language/TeamPlan';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch): DispatchFromProps => ({
  setLanguage: (newLanguage: LanguageCode) => {
    dispatch(languageSelect(newLanguage));
  },
});

export default connect<object, DispatchFromProps, object, Store>(
  mapStateToProps,
  mapDispatchToProps
)(LanguageSelect);
